import { CircularProgress, Paper } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useLogoutMutation } from '../../api/authApiSlice';
import { setUser } from '../../store/slices/authSlice';

export default function Logout() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [logout] = useLogoutMutation();

    useEffect(() => {
        logout();
        dispatch(setUser({}));
        navigate('/guest-feed');
    }, [dispatch, logout, navigate]);

    return (
        <Paper
            className="d-flex align-items-center justify-content-center"
            onClick={() => navigate('/guest-feed')}
            sx={{ borderRadius: 0, minHeight: '100vh' }}
        >
            <CircularProgress />
        </Paper>
    );
}
